import { useRef } from "react";
import { Box } from "@mui/material";
import { motion, useScroll, useTransform } from "framer-motion";
import { useMotionConfig } from "./useMotionConfig";

const MotionBox = motion(Box);

/**
 * Scroll-linked parallax wrapper. As the element travels through the
 * viewport, its content is shifted vertically by `speed` * distance.
 * Positive speed => moves slower than scroll (recedes), giving depth.
 *
 * On mobile / reduced-motion the effect is disabled and children render
 * statically, matching the responsive requirement.
 */
export default function Parallax({ children, speed = 0.25, sx, ...rest }) {
  const ref = useRef(null);
  const { lightMode } = useMotionConfig();

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const distance = 120 * speed;
  const y = useTransform(scrollYProgress, [0, 1], [distance, -distance]);

  if (lightMode) {
    return (
      <Box ref={ref} sx={sx} {...rest}>
        {children}
      </Box>
    );
  }

  return (
    <MotionBox ref={ref} sx={sx} style={{ y }} {...rest}>
      {children}
    </MotionBox>
  );
}
